import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Loader from "../../../components/Loader";
import Discussion from "../../../components/discussion/Discussion";
import {
  createQuestion,
  getMyQuestions,
  getQuestions,
} from "../../../services/api/queries/forum";
import { Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import ModalFormOpener from "../../../components/actions/ModalFormOpener";
import questionFields from "../../../configs/meta/formFields/questionFields";

const MyDiscussion = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  let navigate = useNavigate();

  const params = useParams();

  const performQuery = useCallback(() => {
    console.log(params, "====");
    setIsLoading(true);
    const res = getMyQuestions(params)
      .then((info) => {
        if (!info.success) throw info;
        setQuestions(info.data);
        return info;
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
    return res;
  }, [params]);

  useEffect(() => {
    performQuery();
  }, [performQuery]);

  useEffect(() => {
    performQuery();
  }, [performQuery]);

  return (
    <React.Fragment>
      <Helmet title="My Courses  Page" />
      <Loader className="h-100" minHeight={false} isLoading={isLoading}>
        <Container fluid className="p-0 my-courses">
          <h1 className="h3 mb-3 top-title">My Questions</h1>
          {!questions.length ? (
            <div className="my-courses">
              <div className="d-flex justify-content-center align-items-center my-5">
                <div className="no-course-card">
                  <div className="mx-auto text-center">
                    <h3 className="title">You have no question!</h3>
                    <div className="d-flex justify-content-center align-items-center">
                      <ModalFormOpener
                        key="create"
                        submitService={createQuestion}
                        fields={questionFields}
                        heading={"Write your Post!"}
                        openerText="Write your Post"
                        size="xl"
                        doNotReset={true}
                        successMessage="Question Created!"
                        openerClassName="btn_primary btn_md mx-auto"
                        appendPayload={params}
                        refreshEvent="refresh_questions"
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </Container>
        {questions.length ? (
          <div className=" h-100">
            <div className="row d-flex h-100">
              <div className="col-md-12 h-100">
                <div
                  className="discussion-section p-lg-5 h-100"
                  style={{ cursor: "default" }}
                >
                  <div className="discussion-container">
                    {questions.map((question) => (
                      <Discussion
                        key={question.id}
                        question={question}
                        course_id={question.forum.course}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </Loader>
    </React.Fragment>
  );
};
export default MyDiscussion;
